import { useState } from 'react'
import './NPS-slider.scss'
// hooks
import useNPS from '../../../hooks/useNPS'
// contentFull
import { useContentfulNPS } from '../../../hooks/contentful'
// utils
import sendGaPush from '../../../utils/sendGaPush'
// components
import Image from '../../atoms/Image/image'
import FormExperience from '../forms/form-experience/form-experience'
import FormSpeedService from '../forms/form-speed-service/form-speed-service'
import FormTextExperience from '../forms/form-text-experience/form-text-experience'
import Loading from '../../atoms/loading/loading'
import Button from '../../atoms/button/button'
import BlankPage from '../../atoms/blank-page/blank-page'
import { useLocation } from 'react-router-dom'
import listRoutes from 'routes/listRoutes'
import useRouterControl from 'hooks/useRouterControl'
const NPSSlider = () => {
	// state
	const [isForm, setIsForm] = useState(0)
	// location
	const { pathname } = useLocation()
	// hooks
	const { routerControl } = useRouterControl()
	const {
		experienceAnswer,
		speedAnswer,
		textAnswer,
		loading: stateLoading,
		setValue,
		handledSaveNPS,
		handleCloseModal
	} = useNPS()

	// content
	const { referenciaContenidoCollection: NTSData, loading, error } = useContentfulNPS()
	const {
		imagenPrincipal: image,
		tituloGeneral: title,
		botonCollection: { items } = {},
		tituloDescripcion: description,
		placeholder
	} = NTSData[isForm] || false
	const buttonText = (items && items[0].tituloBoton) || 'Continuar'

	// metrics
	const handleSendGaPush = ({ action = 'ClicCalificaTuExperiencia', label }) => {
		sendGaPush({ category: 'SaludContinuarediseno', action, label })
	}

	// actions
	const nextSlide = () => setIsForm(isForm + 1)

	// render elements
	const render = [
		<FormExperience
			key='FormExperience'
			value={experienceAnswer}
			action={setValue}
			sendData={() => {
				handleSendGaPush({ label: `Experiencia - ${experienceAnswer} ` })
				handledSaveNPS({ callBack: nextSlide })
			}}
			buttonText={buttonText}
		/>,
		<FormSpeedService
			key='speedAnswer'
			value={speedAnswer}
			action={setValue}
			sendData={() => {
				handleSendGaPush({ label: `Velocidad - ${speedAnswer} ` })
				handledSaveNPS({ callBack: nextSlide })
			}}
			buttonText={buttonText}
		/>,
		<FormTextExperience
			key='textAnswer'
			value={textAnswer}
			required={experienceAnswer < 4}
			action={setValue}
			sendData={() => {
				handleSendGaPush({ label: `Comentario - ${textAnswer} ` })
				handledSaveNPS({ callBack: nextSlide, last: true })
			}}
			buttonText={buttonText}
			placeholder={placeholder}
		/>,
		<div key='final'>
			{description && <p>{description}</p>}
			{buttonText && (
				<Button
					uppercase
					title={buttonText}
					classes='pink mt2'
					onClick={() => {
						if (pathname === listRoutes.programQualify) {
							return routerControl({ link: listRoutes.yourServices })
						}
						handleCloseModal()
					}}
				/>
			)}
		</div>
	]

	const lastElement = isForm + 1 === render.length

	if (loading) return <Loading small={true} />

	if (error) return <BlankPage />

	return (
		<div className='m-nps-slider'>
			{image && (
				<Image
					classes='m-nps-slider__img'
					alt={image.title}
					src={image.url}
					height={lastElement ? '66' : '110'}
					width={lastElement ? '66' : '120'}
				/>
			)}

			{title && <h3 className='mb1'>{title}</h3>}

			{stateLoading ? <Loading small /> : render[isForm] || render[0]}
		</div>
	)
}

export default NPSSlider
